import { CheckCircle2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function SuccessScreen({ request, onReset }) {
  const nav = useNavigate();
  return (
    <div data-testid="service-request-confirmation" className="mx-auto max-w-2xl px-4 py-16 text-center">
      <CheckCircle2 size={44} className="mx-auto text-[var(--yp-success)]" />
      <h1 className="font-serif-display text-3xl text-[var(--yp-primary)] mt-4">Site visit request received</h1>
      <p className="text-[var(--yp-muted)] mt-2">Thank you. Our team will review your requirement and contact you to confirm the next step.</p>
      <div className="mt-6 bg-white border border-[var(--yp-border)] rounded-2xl p-6 text-left space-y-2">
        <div><span className="text-[var(--yp-muted)] text-xs">Request ID</span><div data-testid="service-request-id" className="font-semibold">{request.id}</div></div>
        <div><span className="text-[var(--yp-muted)] text-xs">Service</span><div className="font-medium">{request.visit_type}</div></div>
        <div><span className="text-[var(--yp-muted)] text-xs">Date &amp; Time</span><div className="font-medium">{request.date} · {request.time}</div></div>
        <div><span className="text-[var(--yp-muted)] text-xs">Location</span><div className="font-medium">{request.address}, {request.city}, {request.state} - {request.pincode}</div></div>
      </div>
      <div className="mt-6 flex items-center justify-center gap-3">
        <button onClick={() => nav("/")} className="btn-primary rounded-full px-6 py-3 text-sm font-medium">Back to home</button>
        <button onClick={onReset} className="rounded-full border border-[var(--yp-border)] px-6 py-3 text-sm font-medium hover:border-[var(--yp-primary)]">Submit another request</button>
      </div>
    </div>
  );
}
